import React from 'react';

import './SignatureField.scss';

declare interface SignatureFieldProps {
  nrOfOrders?: number;
  sumParcels?: number;
}
export function SignatureField({
  nrOfOrders = 0,
  sumParcels = 0,
}: SignatureFieldProps) {
  return (
    <div className="u-pbl">
      <div className="signatureArea">
        <div className="signatureField-data-today__summary">
          <p>ORDERS: {nrOfOrders}</p>
          <p>PARCELS: {sumParcels}</p>
        </div>
        <div className="SignatureFieldBox  u-print-only">
          <div className="signatureText">Signature: </div>
          <div>
            ____________________________________________________________
          </div>
        </div>
      </div>
    </div>
  );
}
